import { useMemo, forwardRef, useImperativeHandle, useRef } from 'react';

import InputSelect from '@/components/InputSelect';

// 库存输入框
const PurchaseNumberInputs = forwardRef((props, ref) => {
  const loop = () => {};

  const { productVO, totalStockNumber, onChange = loop, onChangeUseInputCount } = props;
  const InputSelectRef = useRef(null);

  useImperativeHandle(ref, () => ({
    validate: (value) => {
      return InputSelectRef.current.validate(value);
    },
  }));

  // c商品转p商品只是显示单输入框
  const defaultCount = useMemo(() => {
    if (productVO?.productUnsealVendition == 'no') {
      return '商品已停售';
    }
    if (productVO?.selfProductCode) {
      return productVO?.minBuyNumber;
    }
    return productVO?.minBuyNumber * productVO?.theRatio || '';
  }, [productVO]);

  const productMinEncapsulationNumber = useMemo(() => {
    if (productVO?.selfProductCode) {
      return null;
    }
    return productVO?.productMinEncapsulationNumber;
  }, [productVO]);

  const productMinEncapsulationUnit = useMemo(() => {
    if (productVO?.selfProductCode) {
      return null;
    }
    return productVO?.productMinEncapsulationUnit;
  }, [productVO]);

  const minBuyNumber = useMemo(() => {
    if (productVO?.selfProductCode) {
      return productVO?.minBuyNumber;
    }
    return productVO?.minBuyNumber * productVO?.theRatio;
  }, [productVO]);

  const stockNumber = useMemo(() => {
    if (
      productVO?.selfProductCode ||
      productVO?.isMarkAutoOffShelves === 'yes' ||
      productVO?.productCycle === 'stop_product'
    ) {
      return totalStockNumber;
    }
    return null;
  }, [productVO, totalStockNumber]);

  return (
    <InputSelect
      ref={InputSelectRef}
      defaultCount={defaultCount}
      defaultUnit={productVO?.productUnit}
      productUnit={productVO?.productUnit}
      productMinEncapsulationUnit={productMinEncapsulationUnit}
      productMinEncapsulationNumber={productMinEncapsulationNumber}
      stockNumber={stockNumber}
      minBuyNumber={minBuyNumber}
      theRatio={productVO?.theRatio}
      disabled={productVO?.productUnsealVendition === 'no'}
      onChange={(value) => onChange(value)}
      onChangeUseInputCount={onChangeUseInputCount}
    ></InputSelect>
  );
});

PurchaseNumberInputs.displayName = 'PurchaseNumberInputs';

export default PurchaseNumberInputs;
